import styled from "styled-components";
import { MOBILE_BREAKPOINT_NUMBER } from "../../styles/breakpoints";
import { MainButton, MainButtonProps } from "./MainButton";
import { TextButton, TextButtonProps } from "./TextButton";

type Props = {
  textButton?: TextButtonProps;
  mainButton?: MainButtonProps;
  className?: string;
  column?: boolean;
};

export const ButtonGroup = ({
  textButton,
  mainButton,
  className,
  column,
}: Props) => {
  return (
    <Container className={className} $column={column}>
      {textButton && <TextButton {...textButton} />}
      {mainButton && <MainButton {...mainButton} />}
    </Container>
  );
};

const Container = styled.div<{ $column?: boolean }>`
  display: flex;
  flex-direction: ${({ $column }) => ($column ? "column-reverse" : "row")};
  gap: 20px;
  width: 100%;
  justify-content: flex-end;
  align-items: ${({ $column }) => ($column ? "center" : "flex-end")};
  padding: 10px 0 10px 0;
  @media (max-width: ${MOBILE_BREAKPOINT_NUMBER - 40}px) {
    flex-direction: column-reverse;
    gap: 10px;
    align-items: center;
  }
`;
